import { heroEquipment } from "../HeroEquipment";

export const raubritterzy = {
  heroes: {
    "Herszt raubritterów": {
      id: 0,
      startingEquipment: ["Sztylet", "Miecz"],
      cost: 55,
      number: 1,
      equipmentList:
        heroEquipment["Raubritterzy z Księstw Granicznych"].Bohaterowie,
      type: "Bohater",
      stats: {
        Początkowa: [4, 4, 4, 3, 3, 2, 4, 1, 8],
        Maksymalna: [5, 6, 6, 4, 4, 3, 6, 4, 9],
      },
      rules: ["Dowódca", "Zasadzka"],
      exp: 20,
      skills: [0, 1, 2, 3, 4, 5],
    },
    Czarownik: {
      id: 1,
      startingEquipment: ["Sztylet", "Kostur"],
      cost: 35,
      number: 1,
      equipmentList:
        heroEquipment["Raubritterzy z Księstw Granicznych"].Bohaterowie,
      type: "Bohater",
      stats: {
        Początkowa: [4, 3, 3, 3, 3, 1, 3, 1, 8],
        Maksymalna: [5, 6, 6, 4, 4, 3, 6, 4, 9],
      },
      rules: ["Guślarstwo", "Mag (Kolegia Magii)", "Zasadzka"],
      exp: 12,
      skills: [2, 4, 5],
    },
    Kłusownik: {
      id: 2,
      startingEquipment: ["Sztylet", "Kusza"],
      cost: 25,
      number: 2,
      equipmentList:
        heroEquipment["Raubritterzy z Księstw Granicznych"].Bohaterowie,
      type: "Bohater",
      stats: {
        Początkowa: [4, 3, 4, 3, 3, 1, 3, 1, 7],
        Maksymalna: [5, 6, 6, 4, 4, 3, 6, 4, 9],
      },
      rules: ["Pułapkarz", "Ranger", "Zasadzka", "Zwiadowca"],
      exp: 8,
      skills: [0, 1, 4, 5],
    },
    Raubritter: {
      id: 3,
      startingEquipment: ["Sztylet", "Łapacz"],
      cost: 25,
      number: 1,
      equipmentList:
        heroEquipment["Raubritterzy z Księstw Granicznych"].Bohaterowie,
      type: "Bohater",
      stats: {
        Początkowa: [4, 3, 3, 3, 3, 1, 3, 1, 7],
        Maksymalna: [5, 6, 6, 4, 4, 3, 6, 4, 9],
      },
      rules: ["Handlarz niewolników", "Zasadzka", "Żertwa"],
      exp: 8,
      skills: [0, 3, 5],
    },
    Niewolnik: {
      id: 4,
      startingEquipment: ["Broń improwizowana"],
      cost: 10,
      number: 15,
      equipmentList: {},
      type: "Stronnik",
      stats: {
        Początkowa: [4, 2, 2, 3, 3, 1, 3, 1, 2],
        Maksymalna: [5, 6, 6, 4, 4, 3, 6, 4, 9],
      },
      rules: ["Mięso armatnie", "Niewolnik", "Rozmiar rzondzi"],
    },
    Banita: {
      id: 5,
      startingEquipment: ["Sztylet"],
      cost: 20,
      number: 15,
      equipmentList:
        heroEquipment["Raubritterzy z Księstw Granicznych"].Stronnicy,
      type: "Stronnik",
      stats: {
        Początkowa: [4, 3, 3, 3, 3, 1, 3, 1, 7],
        Maksymalna: [5, 6, 6, 4, 4, 3, 6, 4, 9],
      },
      rules: ["Chorążowie & sygnaliści", "Drużyna obsługi", "Zasadzka"],
    },
    Myśliwy: {
      id: 6,
      startingEquipment: ["Sztylet", "Łuk"],
      cost: 20,
      number: 7,
      equipmentList:
        heroEquipment["Raubritterzy z Księstw Granicznych"].Stronnicy,
      type: "Stronnik",
      stats: {
        Początkowa: [4, 3, 3, 3, 3, 1, 3, 1, 7],
        Maksymalna: [5, 6, 6, 4, 4, 3, 6, 4, 9],
      },
      rules: ["Ranger", "Zasadzka", "Zwiadowca"],
    },
    Zbójca: {
      id: 7,
      startingEquipment: ["Sztylet", "Miecz"],
      cost: 30,
      number: 5,
      equipmentList:
        heroEquipment["Raubritterzy z Księstw Granicznych"].Stronnicy,
      type: "Stronnik",
      stats: {
        Początkowa: [4, 4, 3, 3, 3, 1, 3, 1, 7],
        Maksymalna: [5, 6, 6, 4, 4, 3, 6, 4, 9],
      },
      rules: ["Szermierz"],
    },
    Rozbójnik: {
      id: 8,
      startingEquipment: [
        "Sztylet",
        "Miecz",
        "Pistolet",
        "Koń bojowy",
        "Siodło & uprząż",
      ],
      cost: 70,
      number: 3,
      equipmentList:
        heroEquipment["Gang przemytników"]["Rozbójnik"],
      type: "Stronnik",
      stats: {
        Początkowa: [4, 3, 3, 3, 3, 1, 3, 1, 7],
        Maksymalna: [5, 6, 6, 4, 4, 3, 6, 4, 9],
        "Koń bojowy": [8, 3, 0, 3, "-", "-", 3, 1, 5],
      },
      rules: ["Kawalerzysta", "Lekka jazda", "Rajtar", "Zasadzka"],
    },
    Ogr: {
      id: 9,
      startingEquipment: ["Maczuga ogrów"],
      cost: 160,
      number: 1,
      equipmentList: heroEquipment["Raubritterzy z Księstw Granicznych"].Ogr,
      type: "Stronnik",
      stats: {
        Początkowa: [6, 3, 2, 4, 4, 3, 2, 2, 7],
        Maksymalna: [6, 6, 5, 5, 5, 5, 6, 5, 9],
      },
      rules: [
        "Bycza szarża",
        "Duży cel",
        "Głód trzewi",
        "Oznakowany gnoblar (gnoblar-uwaga)",
        "Przepastne trzewia",
        "Strach",
        "Tempy",
        "Wielkolud",
      ],
    },
    Więźniarka: {
      id: 10,
      startingEquipment: [],
      cost: 175,
      number: 1,
      equipmentList: {},
      type: "Machina",
      stats: {
        Powóz: ["-", "-", "-", 4, 8, 8, "-", "-", "-"],
        Koń: [8, 3, 0, 3, "-", "-", 3, 1, 5],
        "Koń ": [8, 3, 0, 3, "-", "-", 3, 1, 5],
      },
      rules: ["Duży cel", "Machina wojenna", "Powóz", "Więźniarka"],
    },
    Rydwan: {
      id: 11,
      startingEquipment: [],
      cost: 125,
      number: 1,
      equipmentList: {},
      type: "Machina",
      stats: {
        Rydwan: ["-", "-", "-", 5, 5, 8, "-", "-", "-"],
        Koń: [8, 3, 0, 3, "-", "-", 3, 1, 5],
        "Koń ": [8, 3, 0, 3, "-", "-", 3, 1, 5],
      },
      rules: ["Duży cel", "Machina wojenna", "Rydwan"],
    },
  },
  limit: 500,
  minModels: 3,
  maxModels: 15,
  name: "Raubritterzy z Księstw Granicznych",
  nature: "Zła",
  armyRules: [
    "Kontakty handlowe (1)",
    "Raubritterzy",
    "Podatek",
    "Rozrzutność",
  ],
  mercenaries: [
    "Balistyk",
    "Bombardier",
    "Czarownica",
    "Gladiator",
    "Goniec",
    "Kartograf",
    "Kupiec",
    "Latarnik",
    "Łowca nagród",
    "Magus",
    "Medyk",
    "Minstrel",
    "Miotacz ołowiu",
    "Ochroniarz",
    "Pogromca Trolli",
    "Poszukiwacz złota",
    "Rozbójnik",
    "Rycerz najemny",
    "Skryba",
    "Strażnik dróg",
    "Szczurołap",
    "Szpieg",
    "Tileański kusznik",
    "Trefniś",
    "Woźnica",
    "Wróżbita",
    "Złodziej",
    "Zwadźca",
    "Zwiadowca",
  ],
};
